import React from 'react';

const avatarPlaceholder = process.env.PUBLIC_URL + '/assets/avatar-placeholder.png';

export interface TestimonialCardProps {
  quote?: string;
  title?: string;
  description?: string;
  avatarUrl?: string;
  className?: string;
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({
  quote = '"Quote"',
  title = 'Title',
  description = 'Description',
  avatarUrl,
  className = ''
}) => {
  return (
    <div className={`bg-background-default border border-border-default rounded-200 p-600 flex flex-[1_0_0] flex-col gap-600 items-start min-w-[300px] ${className}`}>
      {/* Quote */}
      <div className="flex items-start w-full">
        <p className="flex-1 min-h-0 min-w-0 text-heading font-semibold text-text-default leading-[1.2] tracking-[-0.48px] whitespace-pre-wrap">
          {quote}
        </p>
      </div>
      
      {/* Avatar Block */}
      <div className="flex gap-300 items-start w-[139px]">
        <div className="overflow-hidden rounded-full w-[40px] h-[40px] shrink-0 relative">
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[40px] h-[40px]">
            <img 
              src={avatarUrl || avatarPlaceholder} 
              alt={title}
              className="absolute inset-0 w-full h-full object-cover object-center pointer-events-none"
            />
          </div>
        </div>
        <div className="flex-1 min-h-0 min-w-0 flex flex-col gap-50 items-start leading-[0]">
          <div className="flex flex-col justify-center w-full">
            <p className="text-body-medium font-semibold text-text-default-secondary leading-[1.4] whitespace-pre-wrap">
              {title}
            </p>
          </div>
          <div className="flex flex-col justify-center w-full">
            <p className="text-body-medium font-regular text-text-default-tertiary leading-[1.4] whitespace-pre-wrap">
              {description}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;

